import FavoriteEntitiesStore from "../states/favorite-entities.store";
import LocalStorageService from "./local-storage.service";
var FavoriteService = /** @class */ (function () {
    function FavoriteService() {
        FavoriteEntitiesStore.setState(FavoriteService.getFavoriteList());
    }
    FavoriteService.getInstance = function () {
        if (!FavoriteService.instance) {
            FavoriteService.instance = new FavoriteService();
        }
        return FavoriteService.instance;
    };
    FavoriteService.getFavoriteList = function () {
        var values = LocalStorageService.getItem(FavoriteService.key);
        if (!values) {
            values = [];
        }
        return values;
    };
    FavoriteService.getFavorite = function (favoriteId) {
        return this.getFavoriteList().find(function (_a) {
            var id = _a.id;
            return id === favoriteId;
        });
    };
    FavoriteService.addFavorite = function (favorite) {
        var favorites = this.getFavoriteList();
        var index = favorites.findIndex(function (_a) {
            var id = _a.id;
            return id === favorite.id;
        });
        if (index < 0) {
            favorites.push(favorite);
        }
        LocalStorageService.setItem(FavoriteService.key, favorites);
        FavoriteEntitiesStore.setState(favorites);
    };
    FavoriteService.removeFavorite = function (favoriteId) {
        var favorites = this.getFavoriteList();
        var index = favorites.findIndex(function (_a) {
            var id = _a.id;
            return id === favoriteId;
        });
        if (index >= 0) {
            favorites.splice(index, 1);
        }
        LocalStorageService.setItem(FavoriteService.key, favorites);
        FavoriteEntitiesStore.setState(favorites);
    };
    FavoriteService.toggleFavoriteFromStorage = function (favorite) {
        var values = this.getFavoriteList();
        var index = values.findIndex(function (_a) {
            var id = _a.id;
            return id === favorite.id;
        });
        if (index < 0) {
            values.push(favorite);
        }
        else {
            values.splice(index, 1);
        }
        LocalStorageService.setItem(FavoriteService.key, values);
        FavoriteEntitiesStore.setState(values);
        return index < 0;
    };
    FavoriteService.key = 'shupp-favorites';
    return FavoriteService;
}());
FavoriteService.getInstance();
export default FavoriteService;
